import React from "react";
import { Link } from "react-router-dom";
import type { FC } from "react";
import { useStyles } from "./styles";

interface ISlidesCardsMoreProps {
  to: string;
}

export const RecentlyCardsMore: FC<ISlidesCardsMoreProps> = ({ children, to }) => {
  const classes = useStyles();
  return (
    <Link to={to} className={classes.more}>
      {children}
    </Link>
  );
};

